import React, { useContext, useState, useEffect } from "react";
import { Image, Menu, Typography, Divider } from "antd";
import { Link } from "react-router-dom";
import {
  LogoutOutlined,
  UserOutlined,
  ContainerFilled,
  CarFilled,
  TrademarkOutlined,
  CopyrightOutlined,
  ContainerOutlined,
  SendOutlined,
  RightOutlined,
  RocketOutlined,
  MailOutlined,
  BarsOutlined,
  ControlOutlined,
  CloseCircleOutlined,
  CalculatorOutlined,
  ProductOutlined,
  MediumOutlined,
  AuditOutlined,
  UsergroupAddOutlined,
  TruckOutlined,
  FileTextOutlined,
  GiftOutlined,
  ShoppingCartOutlined,
  AimOutlined,
  HomeOutlined,
  SettingOutlined,
  GlobalOutlined,
  RightSquareOutlined,
  WhatsAppOutlined,
  DashboardOutlined,
} from "@ant-design/icons";

import { LoginContext } from "../components/seguridad/servicios/LoginServicios";
import { FormattedMessage } from "react-intl";
import { useTranslation } from "react-i18next";
import MenuPrincipalStyles from "./MenuPrincipalStyles";
// import TipoRuta from "../modulos/tiporuta/TipoRuta";
// import FormAddTipoRuta from "../modulos/tiporuta/FormAddTipoRuta";

const { SubMenu } = Menu;
const { Text } = Typography;

const REACT_APP_LOGO = process.env.REACT_APP_LOGO;

const MenuPrincipal = ({ collapsed, ...props }) => {
  const { logout } = useContext(LoginContext);

  const [openKeys, setOpenKeys] = useState([]);

  const { t } = useTranslation();

  let funcionalidades = sessionStorage.getItem("funcionalidades")
    ? JSON.parse(sessionStorage.getItem("funcionalidades"))
    : null;

  useEffect(() => {
    if (funcionalidades != null) {
      //abre por defecto el menu Usuarios
      // setOpenKeys(funcionalidades.slice(0,1));
    }
  }, []);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && funcionalidades.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const onMenuClick = (key) => {
    if (key === "0") {
      logout();
    }
  };

  return (
    <div style={{
      height: "100%",
      background: 'linear-gradient(180deg, #0f1960 0%, #253289 50%, #1a237e 100%)',
      position: 'relative',
      overflow: 'hidden',
      minWidth: collapsed ? '80px' : '240px',
      width: collapsed ? '80px' : '240px'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 20%, rgba(255,255,255,0.1) 0%, transparent 50%),
          radial-gradient(circle at 80% 80%, rgba(255,255,255,0.05) 0%, transparent 50%),
          linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.02) 50%, transparent 70%)
        `,
        pointerEvents: 'none'
      }} />

      {/* Logo Section */}
      <div style={{
        padding: collapsed ? '16px 8px' : '24px 16px',
        textAlign: 'center',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        marginBottom: '16px',
        background: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(10px)'
      }}>
        <Image
          width={collapsed ? 40 : 80}
          preview={false}
          src={REACT_APP_LOGO}
          style={{
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
            transition: 'all 0.3s ease'
          }}
        />
        {!collapsed && (
          <div style={{ marginTop: '8px' }}>
            <Text style={{
              color: 'white',
              fontSize: '14px',
              fontWeight: '500',
              display: 'block',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              Smart Delivery
            </Text>
            <Text style={{
              color: 'rgba(255,255,255,0.7)',
              fontSize: '12px',
              display: 'block'
            }}>
              Sistema de Gestión
            </Text>
          </div>
        )}
      </div>

      <MenuPrincipalStyles />

      <Menu
        className={`${collapsed ? "collapseStyle" : "expandedStyle"}`}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        mode="inline"
        onClick={(e) => onMenuClick(e.key)}
        style={{
          overflowY: "auto",
          height: "calc(100% - 140px)",
          borderRight: 0,
          backgroundColor: "transparent",
          color: "#ffffff",
          paddingBottom: '20px'
        }}
        theme="dark"
      >

        {/* Dashboard - Opción principal */}
        <Menu.Item
          key="dashboard"
          style={{
            borderRadius: '8px',
            margin: '8px 16px 16px 16px',
            padding: '12px 16px',
            background: 'linear-gradient(135deg, #49528F 0%, #3d4373 100%)',
            border: '1px solid rgba(73, 82, 143, 0.3)',
            boxShadow: '0 4px 12px rgba(73, 82, 143, 0.3)',
            fontWeight: '600',
            fontSize: '15px',
            color: 'white !important',
            transition: 'all 0.3s ease',
            minHeight: '48px',
            display: 'flex',
            alignItems: 'center'
          }}
          onMouseEnter={(e) => {
            const element = e.currentTarget;
            if (element && element.style) {
              element.style.transform = 'translateY(-2px)';
              element.style.boxShadow = '0 6px 16px rgba(73, 82, 143, 0.4)';
              element.style.background = 'linear-gradient(135deg, #3d4373 0%, #2e3557 100%)';
            }
          }}
          onMouseLeave={(e) => {
            const element = e.currentTarget;
            if (element && element.style) {
              element.style.transform = 'translateY(0)';
              element.style.boxShadow = '0 4px 12px rgba(73, 82, 143, 0.3)';
              element.style.background = 'linear-gradient(135deg, #49528F 0%, #3d4373 100%)';
            }
          }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            width: '100%'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
              borderRadius: '8px',
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(255, 215, 0, 0.3)'
            }}>
              <DashboardOutlined style={{
                color: "white",
                fontSize: '18px'
              }} />
            </div>
            <span style={{
              color: 'white',
              fontSize: '15px',
              fontWeight: '600',
              textShadow: '0 1px 3px rgba(0,0,0,0.3)'
            }}>
              <Link to="/principal" style={{
                color: 'white',
                textDecoration: 'none'
              }}>
                Dashboard
              </Link>
            </span>
          </div>
        </Menu.Item>

        <Divider style={{
          borderColor: 'rgba(255,255,255,0.15)',
          margin: '16px 0',
          borderWidth: '1px'
        }} />

      <SubMenu
        hidden={funcionalidades.indexOf("menu_persona") === -1}
        key="menu_persona"
        icon={
          <div style={{
            background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)'
          }}>
            <UsergroupAddOutlined style={{ color: "white", fontSize: '16px' }} />
          </div>
        }
        title={
          <span style={{
            fontWeight: '500',
            fontSize: '14px',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}>
            {t("menu_principal.menu_persona")}
          </span>
        }
        style={{
          marginBottom: '8px',
          borderRadius: '8px'
        }}
      >
        <Menu.Item
          key="2"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <UsergroupAddOutlined style={{ color: '#4CAF50' }} />
          <span>
            <Link to="/persona" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_persona")}
            </Link>
          </span>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        hidden={funcionalidades.indexOf("menu_manifiesto") === -1}
        key="menu_manifiesto"
        icon={
          <div style={{
            background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(33, 150, 243, 0.3)'
          }}>
            <FileTextOutlined style={{ color: "white", fontSize: '16px' }} />
          </div>
        }
        title={
          <span style={{
            fontWeight: '500',
            fontSize: '14px',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}>
            {t("menu_principal.menu_manifiesto")}
          </span>
        }
        style={{
          marginBottom: '8px',
          borderRadius: '8px'
        }}
      >
        <Menu.Item
          key="15"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <FileTextOutlined style={{ color: '#2196F3' }} />
          <span>
            <Link to="/manifiesto" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_manifiesto")}
            </Link>
          </span>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        hidden={funcionalidades.indexOf("menu_paquetes") === -1}
        key="menu_paquetes"
        icon={
          <div style={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(255, 152, 0, 0.3)'
          }}>
            <GiftOutlined style={{ color: "white", fontSize: '16px' }} />
          </div>
        }
        title={
          <span style={{
            fontWeight: '500',
            fontSize: '14px',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}>
            {t("menu_principal.menu_paquetes")}
          </span>
        }
        style={{
          marginBottom: '8px',
          borderRadius: '8px'
        }}
      >
        <Menu.Item
          key="20"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <GiftOutlined style={{ color: '#FF9800' }} />
          <span>
            <Link to="/facturas" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_paquetes")}
            </Link>
          </span>
        </Menu.Item>

        <Menu.Item
          key="21"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <GlobalOutlined style={{ color: '#FF9800' }} />
          <span>
            <Link to="/address" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_address")}
            </Link>
          </span>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        hidden={funcionalidades.indexOf("menu_entregas") === -1}
        key="menu_entregas"
        icon={
          <div style={{
            background: 'linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%)',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(156, 39, 176, 0.3)'
          }}>
            <ShoppingCartOutlined style={{ color: "white", fontSize: '16px' }} />
          </div>
        }
        title={
          <span style={{
            fontWeight: '500',
            fontSize: '14px',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}>
            {t("menu_principal.menu_entregas")}
          </span>
        }
        style={{
          marginBottom: '8px',
          borderRadius: '8px'
        }}
      >
        <Menu.Item
          key="31"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <TrademarkOutlined style={{ color: '#9C27B0' }} />
          <span>
            <Link to="/routes" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_rutas")}
            </Link>
          </span>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        hidden={funcionalidades.indexOf("menu_vehiculos") === -1}
        key="menu_vehiculos"
        icon={
          <div style={{
            background: 'linear-gradient(135deg, #607D8B 0%, #455A64 100%)',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(96, 125, 139, 0.3)'
          }}>
            <TruckOutlined style={{ color: "white", fontSize: '16px' }} />
          </div>
        }
        title={
          <span style={{
            fontWeight: '500',
            fontSize: '14px',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}>
            {t("menu_principal.menu_vehiculos")}
          </span>
        }
        style={{
          marginBottom: '8px',
          borderRadius: '8px'
        }}
      >
        <Menu.Item
          key="40"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <CarFilled style={{ color: '#607D8B' }} />
          <span>
            <Link to="/tipovehiculo" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_tipos_vehiculos")}
            </Link>
          </span>
        </Menu.Item>
        <Menu.Item
          key="41"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <TruckOutlined style={{ color: '#607D8B' }} />
          <span>
            <Link to="/vehiculo" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_gestionar_vehiculos")}
            </Link>
          </span>
        </Menu.Item>
        <Menu.Item
          key="42"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <RightSquareOutlined style={{ color: '#607D8B' }} />
          <span>
            <Link to="/assignment" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_delivery_assignment")}
            </Link>
          </span>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        hidden={funcionalidades.indexOf("menu_auditoria") === -1}
        key="menu_auditoria"
        icon={
          <div style={{
            background: 'linear-gradient(135deg, #795548 0%, #5D4037 100%)',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(121, 85, 72, 0.3)'
          }}>
            <AuditOutlined style={{ color: "white", fontSize: '16px' }} />
          </div>
        }
        title={
          <span style={{
            fontWeight: '500',
            fontSize: '14px',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}>
            {t("menu_principal.menu_auditoria")}
          </span>
        }
        style={{
          marginBottom: '8px',
          borderRadius: '8px'
        }}
      >
        <Menu.Item
          key="50"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <CarFilled style={{ color: '#795548' }} />
          <span>
            <Link to="/auditoriavehiculo" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_auditoria_vehiculos")}
            </Link>
          </span>
        </Menu.Item>

        <Menu.Item
          key="51"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <UsergroupAddOutlined style={{ color: '#795548' }} />
          <span>
            <Link to="/auditoriapersona" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_auditoria_personas")}
            </Link>
          </span>
        </Menu.Item>

        <Menu.Item
          key="52"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <AuditOutlined style={{ color: '#795548' }} />
          <span>
            <Link to="/auditoriaruta" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_auditoria_ruta")}
            </Link>
          </span>
        </Menu.Item>
      </SubMenu>

      {/*<SubMenu hidden={funcionalidades.indexOf("menu_mzproducts")===-1}   key="menu_mzproducts"  icon={<MediumOutlined style={{color:'white'}}/>}*/}
      {/*    title={<FormattedMessage id="menu_mzproducts" defaultMessage="MZProducts" />}>*/}

      {/*    <Menu.Item key="7" >*/}
      {/*        <ProductOutlined />*/}
      {/*        <span  ><Link to="/tracking">*/}
      {/*            {<FormattedMessage id="sub_menu_tipo_rutas" defaultMessage="Tracking" />}*/}
      {/*                </Link></span>*/}
      {/*    </Menu.Item>*/}
      {/*    <Menu.Item key="5">*/}
      {/*        <AuditOutlined />*/}
      {/*        <span ><Link to="/invoices">*/}
      {/*       {<FormattedMessage id="sub_menu_gestionar_ruta" defaultMessage="Facturas" />}*/}
      {/*         </Link></span>*/}
      {/*    </Menu.Item>*/}
      {/*</SubMenu>*/}

      <Divider style={{
        borderColor: 'rgba(255,255,255,0.2)',
        margin: '16px 0',
        borderWidth: '1px'
      }} />

      <SubMenu
        hidden={funcionalidades.indexOf("menu_variables") === -1}
        key="menu_variables"
        icon={
          <div style={{
            background: 'linear-gradient(135deg, #FF5722 0%, #D84315 100%)',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(255, 87, 34, 0.3)'
          }}>
            <SettingOutlined style={{ color: "white", fontSize: '16px' }} />
          </div>
        }
        title={
          <span style={{
            fontWeight: '500',
            fontSize: '14px',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}>
            {t("menu_principal.menu_variables")}
          </span>
        }
        style={{
          marginBottom: '8px',
          borderRadius: '8px'
        }}
      >
        <Menu.Item
          key="60"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <SettingOutlined style={{ color: '#FF5722' }} />
          <span>
            <Link to="/variables" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_variables")}
            </Link>
          </span>
        </Menu.Item>
        <Menu.Item key="61">
          <WhatsAppOutlined style={{ color: "#25D366" }} />
          <span>
            <Link to="/whatsapp">
              {t("menu_principal.sub_menu_whatsapp")}
            </Link>
          </span>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        hidden={funcionalidades.indexOf("menu_usuarios") === -1}
        key="menu_usuarios"
        icon={
          <div style={{
            background: 'linear-gradient(135deg, #3F51B5 0%, #303F9F 100%)',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(63, 81, 181, 0.3)'
          }}>
            <UserOutlined style={{ color: "white", fontSize: '16px' }} />
          </div>
        }
        title={
          <span style={{
            fontWeight: '500',
            fontSize: '14px',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}>
            {t("menu_principal.menu_usuarios")}
          </span>
        }
        style={{
          marginBottom: '8px',
          borderRadius: '8px'
        }}
      >
        <Menu.Item
          key="1"
          style={{
            borderRadius: '6px',
            margin: '4px 8px',
            background: 'rgba(255,255,255,0.05)'
          }}
        >
          <UserOutlined style={{ color: '#3F51B5' }} />
          <span>
            <Link to="/usuarios" style={{ color: 'rgba(255,255,255,0.9)' }}>
              {t("menu_principal.sub_menu_users")}
            </Link>
          </span>
        </Menu.Item>
      </SubMenu>

      <Divider style={{
        borderColor: 'rgba(255,255,255,0.2)',
        margin: '16px 0',
        borderWidth: '1px'
      }} />

      <Menu.Item
        key="0"
        style={{
          borderRadius: '8px',
          margin: '8px 24px',
          padding: '8px 16px',
          background: 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)',
          border: '1px solid rgba(244, 67, 54, 0.3)',
          boxShadow: '0 2px 8px rgba(244, 67, 54, 0.3)',
          fontWeight: '500',
          color: 'white !important',
          transition: 'all 0.3s ease',
          width: 'auto',
          maxWidth: '200px'
        }}
        onMouseEnter={(e) => {
          const element = e.currentTarget;
          if (element && element.style) {
            element.style.transform = 'translateY(-2px)';
            element.style.boxShadow = '0 4px 12px rgba(244, 67, 54, 0.4)';
          }
        }}
        onMouseLeave={(e) => {
          const element = e.currentTarget;
          if (element && element.style) {
            element.style.transform = 'translateY(0)';
            element.style.boxShadow = '0 2px 8px rgba(244, 67, 54, 0.3)';
          }
        }}
      >
        <LogoutOutlined style={{
          color: "white",
          fontSize: '16px',
          marginRight: '8px'
        }} />
        <span style={{ color: 'white' }}>
          {t("menu_principal.menu_cerrar_session")}
        </span>
      </Menu.Item>
    </Menu>
    </div>
  );
};

export default MenuPrincipal;
